// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var Webapi__Dom__HtmlElement = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__HtmlElement.bs.js");

function stringify(_element) {
  return "domHtmlElement";
}

function ofNodeOrItsAncestor(_node) {
  while(true) {
    var node = _node;
    var match = Curry._1(Webapi__Dom__HtmlElement.ofNode, node);
    var match$1 = node.parentNode;
    if (match !== undefined) {
      return Caml_option.valFromOption(match);
    }
    if (match$1 == null) {
      return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: cannot cast Node into HTMLElement and failed to locate its parent");
    }
    _node = match$1;
    continue ;
  };
}

function parentHtmlElement(htmlElement) {
  var parentElement = htmlElement.parentElement;
  if (!(parentElement == null)) {
    return Webapi__Dom__HtmlElement.ofElement(parentElement);
  }
  
}

function isSiblingOf(e1, e2) {
  var match = e1.parentElement;
  var match$1 = e2.parentElement;
  if (!(match == null) && !(match$1 == null)) {
    return match === match$1;
  } else {
    return false;
  }
}

function t__encode(v) {
  return Js_dict.fromArray([
              [
                "hidden",
                Decco.boolToJson(v.hidden)
              ],
              [
                "isContentEditable",
                Decco.boolToJson(v.isContentEditable)
              ],
              [
                "tagName",
                Decco.stringToJson(v.tagName)
              ],
              [
                "id",
                Decco.stringToJson(v.id)
              ],
              [
                "className",
                Decco.stringToJson(v.className)
              ]
            ]);
}

function t__decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var hidden = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hidden"), null));
  if (hidden.TAG === /* Ok */0) {
    var isContentEditable = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isContentEditable"), null));
    if (isContentEditable.TAG === /* Ok */0) {
      var tagName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tagName"), null));
      if (tagName.TAG === /* Ok */0) {
        var id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
        if (id.TAG === /* Ok */0) {
          var className = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "className"), null));
          if (className.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      hidden: hidden._0,
                      isContentEditable: isContentEditable._0,
                      tagName: tagName._0,
                      id: id._0,
                      className: className._0
                    }
                  };
          }
          var e = className._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".className" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = id._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".id" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = tagName._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".tagName" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = isContentEditable._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".isContentEditable" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = hidden._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".hidden" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function fromDomHtmlElement(htmlElement) {
  return {
          hidden: htmlElement.hidden,
          isContentEditable: htmlElement.isContentEditable,
          tagName: htmlElement.tagName,
          id: htmlElement.id,
          className: htmlElement.className
        };
}

function stringify$1(element) {
  return JSON.stringify(t__encode(element));
}

var ForSerialization = {
  t__encode: t__encode,
  t__decode: t__decode,
  fromDomHtmlElement: fromDomHtmlElement,
  stringify: stringify$1
};

function isNotVisibleOnPage(element) {
  var domRect = element.getBoundingClientRect();
  if (domRect.height <= 1.0) {
    return true;
  } else {
    return domRect.width <= 1.0;
  }
}

function isVisibleOnPage(element) {
  return !isNotVisibleOnPage(element);
}

exports.stringify = stringify;
exports.ofNodeOrItsAncestor = ofNodeOrItsAncestor;
exports.parentHtmlElement = parentHtmlElement;
exports.isSiblingOf = isSiblingOf;
exports.ForSerialization = ForSerialization;
exports.isNotVisibleOnPage = isNotVisibleOnPage;
exports.isVisibleOnPage = isVisibleOnPage;
/* Util-SmartcutsMacros Not a pure module */
